import { createUseStyles } from 'react-jss'

import { COLOR, MQ } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    textDecoration: 'none',
    width: '100%',
    margin: [20, 0],

    [MQ.TABLET]: {
      margin: [25, 0],
    },
    [MQ.TABLET_LARGE]: {
      // width: '27.8%',
      margin: [60, 0],
    },
  },
  image: {
    borderRadius: 20,
  },
  title: {
    alignSelf: 'center',
    color: COLOR.DARK_GREEN,
    marginTop: 10,
  },
  price: {
    alignSelf: 'center',
    color: COLOR.LIGHT_GREEN,
  },
})
